<div class="main-content">
	<div class="container-fluid">
		<div class="header text-center">
			<h3 class="title">Timeline</h3>

<input matInput [matDatepicker]="picker" placeholder="Choose a date">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker #picker></mat-datepicker>

		</div>
		<div class="row">
			<div class="col-md-12">
				<div class="card card-plain">
					<div class="card-content">
						<mat-toolbar>
							<button mat-raised-button (click)="addEntry()">Add Entry</button>
							<button mat-raised-button (click)="removeEntry()">Remove Entry</button>
							<button mat-raised-button (click)="alternate = !alternate">Toggle Alternate</button>
							<button mat-raised-button (click)="toggle = !toggle">Toggle Toggle</button>
							<button mat-raised-button (click)="expandEnabled = !expandEnabled">Toggle Expand Enabled</button>
							<button mat-raised-button (click)="toggleSide()">Toggle Side</button>
							<button mat-raised-button (click)="contentAnimation = !contentAnimation">Toggle Content Animation</button>
						</mat-toolbar>

						<mat-toolbar>
						  <button mat-raised-button (click)="color = !color">Toggle Dot Color</button>
						  <button mat-raised-button (click)="dotAnimation = !dotAnimation">Toggle Dot Animation</button>
						  <button mat-raised-button (click)="size = size + 10">Increase Dot size</button>
						  <button mat-raised-button (click)="size = size - 10">Decrease Dot size</button>
						</mat-toolbar>

						<!-- <mgl-timeline [toggle]="toggle" [alternate]="alternate" [side]="side" >
								<mgl-timeline-entry *ngFor="let entry of entries; let i = index;" (expand)="onExpandEntry($event, i)">
								<mgl-timeline-entry-header (click)="onHeaderClick($event)">
									<div class="timeline-heading"><span class="label label-danger">{{entry.content}}</span></div>
								</mgl-timeline-entry-header>
								<mgl-timeline-entry-content [expandAnimationTiming]="contentAnimation ? '200ms ease' : '0ms'" [collapseAnimationTiming]="contentAnimation ? '100ms ease' : '0ms'">
								<ul  class="timeline" >
									<li class="timeline-inverted">
										<div class="timeline-badge danger">
											<i class="material-icons">card_travel</i></div>
											<div class="timeline-panel">
												<div class="timeline-heading">
													<span class="label label-danger">Order List</span>
												</div>
											</div>
									</li>

								</ul>
								</mgl-timeline-entry-content>
								<mgl-timeline-entry-dot [class]="color ? 'timeline-badge badge badge-primary' : 'timeline-badge danger accent'"
								[size]="size"
								(click)="onDotClick($event)"
								[expandAnimationTiming]="dotAnimation ? '200ms ease' : '0ms'"
								[collapseAnimationTiming]="dotAnimation ? '100ms ease' : '0ms'"
								></mgl-timeline-entry-dot>
									<mgl-timeline-entry-side>
									<div class="timeline-body"><p>TRUCK ORDER INFO</p></div>

									</mgl-timeline-entry-side>
								</mgl-timeline-entry>
							</mgl-timeline> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</div>


<div class="main-content">
	<div class="container-fluid">
		<div class="header text-center">
			<h3 class="title">Timeline</h3>
		</div>
			<div class="row">
				<div class="col-md-12">
					<div class="card card-plain">
						<div class="card-content">
							<ul class="timeline">
								<li class="timeline-inverted">
								<div class="timeline-badge danger">
									<i class="material-icons">card_travel</i></div>
									<div class="timeline-panel">
										<div class="timeline-heading">
											<span class="label label-danger">Some Title</span>
											</div>
											<div class="timeline-body"><p>Wifey made the best Father's Day meal ever. So thankful so happy so blessed. Thank you for making my family We just had fun with the “future” theme !!! It was a fun night all together ... The always rude Kanye Show at 2am Sold Out Famous viewing @ Figueroa and 12th in downtown.</p></div>
											<h6><i class="ti-time"></i> 11 hours ago via Twitter </h6></div></li><li><div class="timeline-badge success"><i class="material-icons">extension</i></div><div class="timeline-panel"><div class="timeline-heading"><span class="label label-success">Another One</span></div><div class="timeline-body"><p>Thank God for the support of my wife and real friends. I also wanted to point out that it’s the first album to go number 1 off of streaming!!! I love you Ellen and also my number one design rule of anything I do from shoes to music to homes is that Kim has to like it....</p></div></div></li><li class="timeline-inverted"><div class="timeline-badge info"><i class="material-icons">fingerprint</i></div><div class="timeline-panel"><div class="timeline-heading"><span class="label label-info">Another Title</span></div><div class="timeline-body"><p>Called I Miss the Old Kanye That’s all it was Kanye And I love you like Kanye loves Kanye Famous viewing @ Figueroa and 12th in downtown LA 11:10PM</p><p>What if Kanye made a song about Kanye Royère doesn't make a Polar bear bed but the Polar bear couch is my favorite piece of furniture we own It wasn’t any Kanyes Set on his goals Kanye</p><hr><div class="dropdown pull-left"><button mat-raised-button="" type="button" data-toggle="dropdown" class="btn btn-round btn-info dropdown-toggle"><i class="material-icons">build</i><span class="caret"></span></button><ul role="menu" class="dropdown-menu dropdown-menu-right"><li><a href="#action">Action</a></li><li><a href="#action">Another action</a></li><li><a href="#here">Something else here</a></li><li class="divider"></li><li><a href="#link">Separated link</a></li></ul></div></div></div></li><li><div class="timeline-badge warning"><i class="material-icons">flight_land</i></div><div class="timeline-panel"><div class="timeline-heading"><span class="label label-warning">Another One</span></div><div class="timeline-body"><p>Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter Tune into Big Boy's 92.3 I'm about to play the first single from Cruel Winter also to Kim’s hair and makeup Lorraine jewelry and the whole style squad at Balmain and the Yeezy team. Thank you Anna for the invite thank you to the whole Vogue team</p></div></div></li></ul></div></div></div></div></div></div>
